import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const PrivacyPage = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      title: "Politique de Confidentialité",
      lastUpdate: "Dernière mise à jour : Mars 2026",
      sections: [
        {
          title: "1. Responsable du traitement",
          text: `Le responsable du traitement des données personnelles collectées sur le site themetalove.com est MetaLove.

Contact : contact@themetalove.com`
        },
        {
          title: "2. Données collectées",
          text: `Dans le cadre de votre candidature à MetaLove, nous collectons les données suivantes :
          
• Prénom
• Adresse email
• Réponses au questionnaire de candidature

Ces données sont nécessaires pour traiter votre candidature et vous recontacter si votre profil correspond à notre approche.`
        },
        {
          title: "3. Finalités du traitement",
          text: `Vos données personnelles sont collectées pour les finalités suivantes :

• Traitement et étude de votre candidature
• Communication avec vous concernant votre candidature
• Amélioration de nos services

Nous ne vendons ni ne partageons vos données personnelles avec des tiers à des fins commerciales.`
        },
        {
          title: "4. Base légale",
          text: `Le traitement de vos données est fondé sur :

• Votre consentement lors de la soumission du formulaire de candidature
• Notre intérêt légitime à développer notre activité`
        },
        {
          title: "5. Durée de conservation",
          text: `Vos données sont conservées pendant une durée de 3 ans à compter de votre dernière interaction avec MetaLove.

Au-delà de cette période, vos données seront supprimées ou anonymisées.`
        },
        {
          title: "6. Vos droits",
          text: `Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :

• Droit d'accès à vos données
• Droit de rectification
• Droit à l'effacement (« droit à l'oubli »)
• Droit à la limitation du traitement
• Droit à la portabilité des données
• Droit d'opposition

Pour exercer ces droits, contactez-nous à : contact@themetalove.com`
        },
        {
          title: "7. Sécurité",
          text: `Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction.`
        },
        {
          title: "8. Cookies",
          text: `Le site themetalove.com utilise uniquement des cookies techniques nécessaires à son bon fonctionnement. Aucun cookie publicitaire ou de traçage n'est utilisé.`
        },
        {
          title: "9. Modifications",
          text: `Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec une date de mise à jour.`
        },
        {
          title: "10. Contact",
          text: `Pour toute question concernant cette politique de confidentialité ou vos données personnelles :

Email : contact@themetalove.com`
        }
      ]
    },
    en: {
      title: "Privacy Policy",
      lastUpdate: "Last updated: March 2026",
      sections: [
        {
          title: "1. Data Controller",
          text: `The data controller for personal data collected on themetalove.com is MetaLove.

Contact: contact@themetalove.com`
        },
        {
          title: "2. Data Collected",
          text: `As part of your application to MetaLove, we collect the following data:
          
• First name
• Email address
• Responses to the application questionnaire

This data is necessary to process your application and contact you if your profile matches our approach.`
        },
        {
          title: "3. Purpose of Processing",
          text: `Your personal data is collected for the following purposes:

• Processing and reviewing your application
• Communicating with you about your application
• Improving our services

We do not sell or share your personal data with third parties for commercial purposes.`
        },
        {
          title: "4. Legal Basis",
          text: `The processing of your data is based on:

• Your consent when submitting the application form
• Our legitimate interest in developing our business`
        },
        {
          title: "5. Retention Period",
          text: `Your data is retained for 3 years from your last interaction with MetaLove.

Beyond this period, your data will be deleted or anonymized.`
        },
        {
          title: "6. Your Rights",
          text: `In accordance with the General Data Protection Regulation (GDPR), you have the following rights:

• Right of access to your data
• Right to rectification
• Right to erasure ("right to be forgotten")
• Right to restriction of processing
• Right to data portability
• Right to object

To exercise these rights, contact us at: contact@themetalove.com`
        },
        {
          title: "7. Security",
          text: `We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, modification, disclosure, or destruction.`
        },
        {
          title: "8. Cookies",
          text: `The themetalove.com website only uses technical cookies necessary for its proper functioning. No advertising or tracking cookies are used.`
        },
        {
          title: "9. Changes",
          text: `We reserve the right to modify this privacy policy at any time. Any changes will be posted on this page with an updated date.`
        },
        {
          title: "10. Contact",
          text: `For any questions regarding this privacy policy or your personal data:

Email: contact@themetalove.com`
        }
      ]
    }
  };

  const c = content[language];

  return (
    <div 
      data-testid="privacy-page"
      className="min-h-screen pt-24 pb-16"
      style={{ backgroundColor: '#050A14' }}
    >
      <div className="max-w-3xl mx-auto px-6">
        {/* Header */}
        <div className="mb-16 text-center">
          <h1 
            className="font-heading text-4xl md:text-5xl font-light mb-4"
            style={{ color: '#D1D5DB' }}
          >
            {c.title}
          </h1>
          <p style={{ color: '#6B7280' }} className="text-sm">
            {c.lastUpdate}
          </p>
          <div className="divider-silver w-20 mx-auto mt-8" />
        </div>

        {/* Content */}
        <div className="space-y-10">
          {c.sections.map((section, index) => (
            <div key={index}>
              <h2 
                className="font-heading text-xl md:text-2xl mb-4"
                style={{ color: '#D1D5DB' }}
              >
                {section.title}
              </h2>
              <div 
                className="font-body text-sm md:text-base leading-relaxed whitespace-pre-line text-justify"
                style={{ color: '#9CA3AF' }}
              >
                {section.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
